import { IsNumberString, IsString } from "class-validator";

export class GiftCardTransactionRefundRequest {
    @IsString()
    @IsNumberString()
    reference: number;

    
    amount: number | string;

}
